const PRODUCT_CONTAINER_CLASSNAME = 'product-detail-vue';
const PRODUCT_CONTAINER_SELECTOR = `.${PRODUCT_CONTAINER_CLASSNAME}`;

export default {
  methods: {
    findSfraProductContainer() {
      let element = this.$el;
      if (!element.classList.contains(PRODUCT_CONTAINER_CLASSNAME)) {
        const closest = element.closest(PRODUCT_CONTAINER_SELECTOR);
        element =
          closest !== null
            ? closest
            : element.querySelector(PRODUCT_CONTAINER_SELECTOR);
      }
      return element;
    },
    sfraSelectSize(size) {
      const container = this.findSfraProductContainer();
      const select = container.querySelector('.select-size');

      if (!$ || select === null) return;

      const $select = $(select);
      const willSizeChange = $select.val() !== size.url;
      if (willSizeChange) {
        if (size.url) {
          $select.val(size.url);
        } else {
          $select.attr('selectedIndex', 0);
        }
        // As it changes programatically, change should be manually triggered
        $select.change();
      }
    },
    sfraSelectQuantity(quantity) {
      const container = this.findSfraProductContainer();
      const select = container.querySelector('.quantity-select');

      if (!$ || select === null) return false;

      const $select = $(select);
      const willQuantityChange = $select.val() !== quantity.toString();
      if (willQuantityChange) {
        // IF the desired quantity isn´t an option, return
        if (!select.querySelector(`option[data-url$="quantity=${quantity}"]`)) {
          return false;
        }
        $select.val(quantity);
        // As it changes programatically, change should be manually triggered
        $select.change();
      }
      return true;
    },
  },
};
